var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5Z",
    fill: "#0F141A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.01 0C6.69772 0 4.01001 2.68772 4.01001 6C4.01001 6.58718 4.09476 7.15722 4.25549 7.7003L0.302902 11.6529C0.115366 11.8404 0.0100098 12.0948 0.0100098 12.36V15.01C0.0100098 15.5623 0.457725 16.01 1.01001 16.01H5.01001C5.56229 16.01 6.01001 15.5623 6.01001 15.01V14.01H8.01001C8.56229 14.01 9.01001 13.5623 9.01001 13.01V11.9262C9.33598 11.9814 9.67034 12.01 10.01 12.01C13.3223 12.01 16.01 9.32228 16.01 6.00999C16.01 2.74958 13.4058 0.0943332 10.1652 0.0119643C10.1146 0.00408787 10.0628 0 10.01 0ZM4.01001 13.01V14.01H2.01001V12.7742L6.11711 8.6671C6.40574 8.37848 6.48997 7.9434 6.32993 7.5679C6.1218 7.07961 6.01001 6.5528 6.01001 6C6.01001 3.83483 7.73389 2.06923 9.88286 2.00199C9.9245 2.00727 9.96694 2.00999 10.01 2.00999C12.2177 2.00999 14.01 3.80228 14.01 6.00999C14.01 8.21771 12.2177 10.01 10.01 10.01C9.44106 10.01 8.89879 9.88981 8.41476 9.67557C8.10546 9.53867 7.74793 9.56739 7.46446 9.75192C7.18099 9.93645 7.01001 10.2518 7.01001 10.59V12.01H5.01001C4.45773 12.01 4.01001 12.4577 4.01001 13.01Z",
    fill: "#0F141A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.3ae56fc22f7e115fb67d5d3b7dbaeb28.svg";
export { ForwardRef as ReactComponent };